import '../../styles/styles.css';

import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

import Layout from '../../components/Layout';

import AnimateIn from '../../components/AnimateIn';
import VimeoVideo from '../../components/VimeoVideo';
import Image from '../../components/Image';
import ColumnLists from '../../components/ColumnLists';
import LinkButton from '../../components/LinkButton';
import LinkList from '../../components/LinkList';
import Quote from '../../components/Quote';
import WorkHeader from '../../components/WorkHeader';

import { getProject } from '../../config/general';
import hardcodedStaticProps from '../../lib/harcodedStaticProps';

const Fila = ({featuredProjectsList}) => {
  const project = getProject('fila');

  return (
    <Layout metaData={{ data: project }} featuredProjectsList={featuredProjectsList}>
      <article className="components page">
        <WorkHeader component={{ project }} />

        <VimeoVideo
          component={{
            posterVideo: '395699047'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="launching-a-new-category-globally">Launching a new collection globally</h2>
          <p>
            With the rising demand for outdoor-inspired streetwear, FILA introduced EXPLORE—an outdoor clothing collection with design elements that paid homage to the brand’s mountaineering history.
          </p>
          <p>
            Your Majesty worked with FILA North America to create a website that could translate the collection’s ethos digitally and effectively drive traffic to FILA’s e-commerce.
          </p>
        </AnimateIn>

        <VimeoVideo
          component={{
            posterVideo: '395698959'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="preparing-for-launch">Design for immersion and exploration</h2>
          <p>
            The EXPLORE collection comprised of four fashion stories—canyon, woods, mountain, and elements. 
            Each had its own immersive visual language that we brought to life through four corresponding visual effects.
          </p>
          <p>
            To echo the collection’s focus, we created a website that was minimal at first glance, 
            and then progressively disclosed visual effects and animations as the visitor explored the site further.
          </p>
        </AnimateIn>

        <Image
          className=""
          component={{
            image:
              'fila/fila-explore-Image-02.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="exceeding-engagement-and-performance-kpis">
            Outcomes
          </h2>
            <ul>
              <li>A 36% click-through-rate to FILA’s e-commerce</li>
              <li>Webpick of the Day by <a href="https://www.commarts.com/webpicks/fila-explore" target="_blank">Communication Arts</a></li>
              <li>Awarded <a href="https://yourmajesty.co/news/fila-explore-takes-home-three-awwwards" target="_blank">Awwwards Site of the Day</a></li>
              <li>Awarded <a href="https://yourmajesty.co/news/fila-explore-takes-home-three-awwwards" target="_blank">Awwwards Mobile Excellence Award</a></li>
              <li>Awarded <a href="https://yourmajesty.co/news/fila-explore-takes-home-three-awwwards" target="_blank">Awwwards Developer Excellence Award</a></li>
            </ul>
            <p>
              For more coverage, visit <a href="https://www.commarts.com/webpicks/fila-explore" target="_blank">Communication Arts</a>, <a href="https://www.highsnobiety.com/p/fila-explore-pop-ups/" target="_blank">Highsnobiety</a>, <a href="https://hypebeast.com/2019/8/fila-explore-new-york-city-pop-up-event-recap" target="_blank">Hypebeast</a>, and <a href="https://www.teenvogue.com/story/fila-new-explore-outdoors-collection" target="_blank">Teen Vogue.</a> 
            </p>
        </AnimateIn>
        
        <Image
          className=""
          component={{
            image: 'fila/fila-explore-Image-03.jpg'
            }}
        />
        
        <AnimateIn className="text g-row">
          <Quote
            className="g-row quote--marks"
            component={{
              quote:
                'The Your Majesty team was passionate and prompt. \
                They understood our goals for creative design and engaging user interaction \
                while highlighting all aspects of the FILA Explore campaign.',
              quotee: 'Maya Yearwood — Brand Manager, FILA North America'
            }}
          />
   
          <h2 id="more-case-studies">More case studies</h2>
          <p>
            For more projects like FILA Explore, check out our work for <a href="../work/adidas">adidas</a>,{' '}
            <a href="../work/i-t-hong-kong">
              I.T Hong Kong
            </a>,{' '}and{' '}
              <a href="../work/thakoon">Thakoon.</a>
          </p>
    
          <h2 id="more-case-studies">State of Digital Fashion</h2>
          <p>
            Our opinion piece on how the fashion industry can be more sustainable and inclusive.{' '}<a href="../news/state-of-digital-fashion">Read more.</a>
          </p>
        </AnimateIn>
    
        <ColumnLists
          className="g-row"
          component={{
            title: 'Services',
            columns: [
              {
                title: 'Insights & Strategy',
                items: [
                  'Data Analysis',
                  'Content & Analytics Audit',
                  'Site Performance Analysis',
                  'Custom Site Events',
                  'Quantitative User Research',
                  'Qualitative User Research',
                  'Workshop & Facilitation',
                  'Insights Mining & Synthesis',
                  'Go-to-market',
                  'Campaign Planning'
                ]
              },

              {
                title: 'Design',
                items: [
                  'Creative Direction',
                  'Art Direction',
                  'UX Design',
                  'Visual Design',
                  'Visual Design'
                ]
              },

              {
                title: 'Technology',
                items: [
                  'Front-end Development',
                  'Back-end Development',
                  'WebGL',
                  'Content Management System',
                  'Localization',
                  'eCommerce',
                  'Systems Architecture'
                ]
              },
              {
                title: 'Delivery & Aftercare',
                items: [
                  'Quality Assurance',
                  'Deployment',
                  'Operations & Maintenance'
                ]
              }
            ]
          }}
        />
      </article>
    </Layout>
  );
};

export { hardcodedStaticProps as getStaticProps };

export default Fila;
